import moment, { DurationInputArg2, unitOfTime } from "moment-timezone";

const ESTZone = "America/New_York";
export const _timestamp = (date: Date) => {
  return Math.floor(date.valueOf() / 1000);
};

export const changeDateTime = (
  dateTimestamp: number,
  h: number,
  m: number,
  s: number
) => {
  if (dateTimestamp === null) {
    return null;
  }
  let date = new Date(dateTimestamp * 1000);
  date.setHours(h);
  date.setMinutes(m);
  date.setSeconds(s);
  return _timestamp(date);
};

export const dayStartTimestamp = (dateTimestamp: number) => {
  let dayStart = new Date(dateTimestamp);
  return changeDateTime(_timestamp(dayStart), 0, 0, 0);
};

export const startOfTimestampEst = (start_of: unitOfTime.StartOf) =>
  moment().tz(ESTZone).startOf(start_of).unix();

export const endOfTimestampEst = (end_of: unitOfTime.StartOf) =>
  moment().tz(ESTZone).endOf(end_of).unix();

export const startOfWithSubtractTimestampEst = (
  what_to_subtract: DurationInputArg2,
  how_many_to_Subtract: number,
  start_Of: unitOfTime.StartOf
) => {
  return moment()
    .tz(ESTZone)
    .subtract(how_many_to_Subtract, what_to_subtract)
    .startOf(start_Of)
    .unix();
};

export const endOfWithSubtractTimestampEst = (
  what_to_subtract: DurationInputArg2,
  how_many_to_Subtract: number,
  end_of: unitOfTime.StartOf
) => {
  return moment()
    .tz(ESTZone)
    .subtract(how_many_to_Subtract, what_to_subtract)
    .endOf(end_of)
    .unix();
};

export const dateFormatMDY = (time_stamp: number) =>
  moment(time_stamp).format("MMM DD, YYYY");

export const dateTimeFormat = (time_stamp: number) =>
  moment(time_stamp).format("DD MMM YYYY  • h:mm A");

export const unixTimeStampToDate = (time_stamp: number, dateFormat?: string) =>
  moment.unix(time_stamp).format(dateFormat? dateFormat : "DD MMM YYYY • h:mm A");

export const formatDateYYMMDD = (input: string) => {
  const dateObj = new Date(input);
  const date =
    dateObj.getDate() < 10 ? `0${dateObj.getDate()}` : dateObj.getDate();
  const month =
    dateObj.getMonth() < 9
      ? `0${dateObj.getMonth() + 1}`
      : dateObj.getMonth() + 1;
  const dateStr = `${dateObj.getFullYear()}-${month}-${date}`;
  return dateStr;
};

const getTimeZoneFullName = (): string => {
  const today = new Date();
  const fullDate = today.toLocaleDateString(undefined, {
    timeZoneName: "long",
  });
  const timeZoneName = fullDate.split(", ")[1];
  return timeZoneName;
};
const formatTimeWithFullZoneName = (date: string) => {
  return date + " " + "(" + getTimeZoneFullName() + ")";
};
const getTimeZoneName = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
export function getDateWithTimeZone(date: string): string {
  const timeFormat = "ddd MMM D YYYY HH:mm:ss [GMT]ZZ";
  const dateValue = moment.tz(date, getTimeZoneName());
  const formattedDate = dateValue.format(timeFormat);
  return formatTimeWithFullZoneName(formattedDate);
}
